
import { useIvaStore } from "@/store/erp/shared/iva.store";
import { usePlanStore } from "@/store/erp/system-settings/plan.store";
import { useEffect } from "react";
import { Outlet } from "react-router-dom"



const ContabilidadModule = () => {
  
  const getIva = useIvaStore(s=>s.getIva);
  const getPlansCorporativos = usePlanStore(s => s.getPlansCorporativos);


  useEffect(() => {
    (async () => {
      const results = await Promise.allSettled([
        getIva(),
        getPlansCorporativos({ page_size: 300 }),
      ]);
      results.forEach((result, index) => {
        if (result.status === 'rejected') {
          console.error(`Contabilidad data load failed at position ${index}:`, result.reason);
        }
      });
    })();
  }, []);
  return <Outlet />

}

export default ContabilidadModule